import React from 'react';
import styled from 'astroturf/react';

export const SpacerDiv = styled('div')`
  display: block;
  clear: both;
  width: 30px;
`;

type Props = {
  height: number;
};
export const VerticalSpacer: React.FC<Props> = ({ height }) => {
  return <SpacerDiv style={{ height: height }} />;
};
